import { useState } from "react";

export default function RechargeConfirmModal(props) {
  const [errors, setErrors] = useState({});
  const [mpin,setMpin] = useState("");

    const validate = () => {
      const newErrors = errorHandling('rechargeNow');
      setErrors(newErrors);
      if (Object.keys(newErrors).length === 0) {
        props.rechargeNow(mpin);
      }
    }
  
    const errorHandling = (type) => {
      const errors = {};
      if (type === 'rechargeNow') {
          if (!mpin.trim()) {
            errors.mpin = 'Mpin is required';
          }
      }
      return errors;
    };
  return (
    <div
      className="modal fade text-left show"
  id="verify_modal"
  tabIndex={-1}
  role="dialog"
  style={{ display: "block", paddingRight: 15, zIndex:1060 }}
    >
      <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
        <div className="modal-content">
          <div className="modal-header bg-theme-1-subtle">
            <p className="modal-title h5" id="addBeneModal">
              {props.title}
            </p>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={() => props.closeModal('RechargeConfirm')}
            />
          </div>
          <div className="modal-body">
            <div className="mb-1">
              <label className="form-label">Mobile</label>
              <input
                type="text"
                className="form-control"
                placeholder="Account No"
                id="account_number"
                disabled
                value={props.mobile}
              />
            </div>
            <div className="mb-1">
              <label className="form-label">Provider</label>
              <div className="input-group">
                <input
                  type="text"
                  className="form-control"
                  aria-label=""
                  aria-describedby="button-addon2"
                  id="ifsc_code"
                  disabled
                  value={props.provider}
                />
              </div>
            </div>
            <div className="mb-1">
              <label className="form-label">Amount</label>
              <div className="input-group">
                <input
                  type="text"
                  className="form-control"
                  aria-label=""
                  aria-describedby="button-addon2"
                  id="bene_name"
                  disabled
                  value={props.amount}
                />
              </div>
            </div>
            <div className="mb-1">
              <label className="form-label">Mpin</label>
              <div className="input-group">
                <input
                  type="text"
                  className="form-control"
                  aria-label=""
                  aria-describedby="button-addon2"
                  id="bene_name"
                  value={mpin}
                  onChange={(e) => { setMpin(e.target.value) }}
                />
              </div>
                {errors.mpin && (
                  <span className="error-message">
                    {errors.mpin}
                  </span>
                )}
            </div>
          </div>
          <div className="modal-footer">
            <input type="hidden" id="bene_veriry" defaultValue={0} />
            <button
              type="button"
              className="btn btn-theme"
              onClick={validate}
            >
              Recharge Now
            </button>
            <button
              type="button"
              className="btn btn-secondary"
              data-bs-dismiss="modal"
              onClick={() => props.closeModal('RechargeConfirm')}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}